module.exports = __webpack_public_path__ + "media/images/stat__background-040f73659b5c103a50bc93e9b0c90800.jpg";